import React, {PureComponent} from "react";
import {replace} from 'connected-react-router';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import Icon from '../../../../icons/Icon';

import * as styles from "./style.css";
import {createClassNames} from "../../../../../infrastructure/helpers";
import {resetForm} from "../../../store/create-llama/actions";
import {setSidebarVisibility} from '../../../../layout/store/actions';

interface IStickersComponentsScannerHeaderProps {
    onBack: any;
    showBackBtn: boolean;
    theme: string;
    title: string;
}

interface ISStickersComponentsScannerHeaderDispatchProps {
    setSidebarVisibility: (visible: boolean) => Promise<void>;
    showBackBtn: boolean;
    theme: string;
    title: string;
}

type IProps = IStickersComponentsScannerHeaderProps & ISStickersComponentsScannerHeaderDispatchProps


class StickersComponentsScannerHeader extends PureComponent<IProps, {}> {

    static defaultProps = {
        onBack: () => {
        },
        showBackBtn: false,
        theme: 'white',
    };

    static propTypes = {
        onBack: PropTypes.func,
        showBackBtn: PropTypes.bool,
        theme: PropTypes.string,
        title: PropTypes.string.isRequired
    };

    onHamburgerPressed = () => {
        this.props.setSidebarVisibility(true);
    };

    renderBack = (dark) => {
        const iconName = dark ? "HeaderBackDark" : "HeaderBackWhite";
        return (
            <button type="button"
                    onClick={this.props.onBack}
                    className={styles.headerBackBtn}>
                <Icon allowRTL={true} name={iconName} width="20px" height="11px"/>
            </button>
        );
    }

    renderHumburger(dark) {
        const iconName = dark ? "HamburgerDark" : "HamburgerLight";
        return <Icon name={iconName}
                     onClick={this.onHamburgerPressed}
                     className={styles.humburger}/>;
    }

    render() {
        const titleStyles = [styles.title];
        const containerStyles: { backgroundColor?: string } = {};
        let isDark = false;
        if (this.props.theme === 'brand') {
            isDark = true;
            titleStyles.push(styles.titleBrand);
        } else if (this.props.theme === 'white') {
            titleStyles.push(styles.titleWhite);
            containerStyles.backgroundColor = '#0000';
        }
        const titleClassNames = createClassNames(titleStyles);
        return (
            <div className={styles.container} style={containerStyles}>
                {this.props.showBackBtn && this.renderBack(isDark)}
                <div></div>
                <div className={titleClassNames}>{this.props.title}</div>
                {this.renderHumburger(isDark)}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetForm: () => dispatch(resetForm()),
        goHome: () => dispatch(replace('/')),
        setSidebarVisibility: (visible) => dispatch(setSidebarVisibility(visible))
    };
};

export default compose(
    connect(null, mapDispatchToProps),
    withTranslation('cmp-scanner-header'),
)(StickersComponentsScannerHeader);



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/scanner-header/index.tsx